export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = ValidationErrorType;
  }
}

export const ValidationErrorType = "ValidationError";
